  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: routes.root_url + '?sections=cart_content', success: async function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);
        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
        } else {
          summaryWrapper.style.display = 'none';
        }
        await $s.globalEval(data['cart_content']);
        if ($s.syncFreeShippingProgress) {
          await $s.syncFreeShippingProgress();
        }
        $s.hideLoadingOverlay();
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    async function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.updateCartItemsQuantity(data).then(async function(cart) {if ($s.refreshCartItemTags) await $s.refreshCartItemTags(cart);
        await $s.AutoAddRemoveProducts.runAllRules(cart, true);
        $s.skipNextCartAddonReload = true;self.updateCart();
      }).catch($s.addToCartFail);      
    }
  
  };
  //runs every time #cart div is replaced
  if (window.CartCache && CartCache.cart_fetch === null) {
    $s.get({url:'/cart.js'}); //trigger fetch to cache
  }
  var cart = document.getElementById('cart');
  var countHolder = cart.querySelector('[data-cart-count]');
  if (countHolder && window.SideCart && window.SideCart.updateCartCount) {
    window.SideCart.updateCartCount(countHolder.dataset.cartCount);
  } else if (countHolder) {
    var itemsCount = parseInt(countHolder.dataset.cartCount, 10);
    var cartCountElement = document.querySelector('header .cart-count');
    if (cartCountElement && !isNaN(itemsCount)) {
      cartCountElement.innerHTML = itemsCount > 0 ? itemsCount : '';
      if (itemsCount > 0) {
        cartCountElement.parentElement.classList.remove('hide');
      } else {
        cartCountElement.parentElement.classList.add('hide');
      }
    }
    if ($s.updateCartTriggerLabel && !isNaN(itemsCount)) {
      $s.updateCartTriggerLabel(itemsCount);
    }
    var cartCountElementCart = document.querySelector('#cart .cart-count');
    if (cartCountElementCart && !isNaN(itemsCount)) {
      cartCountElementCart.innerHTML = itemsCount > 0 ? itemsCount : '';
    }
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate ? $s.getItemsToUpdate(this.closest('.item'), 0) : [this.closest('.item')];
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('.cart-items input[type=number]').forEach(function(item) {
    item.dataset.lastSubmittedQuantity = item.value;
    var submitCartQuantity = function(input) {
      $s.handleCartQuantityInput(input, function(items, quantity) {
        CartPage.updateItemsQuantity(items, quantity);
      });
    };
    item.addEventListener('change', function() {
      submitCartQuantity(this);
    });
    item.addEventListener('blur', function() {
      $s.clampCartQuantityInput(this);
      submitCartQuantity(this);
    });
  });$s.initCartSellingPlans(cart);

  
  

  if ($s.validateBundlesInJson) {
    $s.getJson({url:'/cart.js'}).then(data=>{
      $s.validateBundlesInJson(data.items);
    })
  }
})();